import { render, staticRenderFns } from "./AcceptTransferModal.vue?vue&type=template&id=37ea57ea&scoped=true&"
import script from "./AcceptTransferModal.vue?vue&type=script&lang=js&"
export * from "./AcceptTransferModal.vue?vue&type=script&lang=js&"
import style0 from "./AcceptTransferModal.vue?vue&type=style&index=0&id=37ea57ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ea57ea",
  null
  
)

export default component.exports